const Forward = () => (
  <>
    <path
      fill="currentColor"
      d="M12 21a7.8 7.8 0 0 0 3.118-.626 8.1 8.1 0 0 0 2.542-1.713 8.1 8.1 0 0 0 1.714-2.543Q20 14.663 20 13a.48.48 0 0 0-.143-.357.48.48 0 0 0-.357-.143.48.48 0 0 0-.357.143A.48.48 0 0 0 19 13q0 2.925-2.038 4.962T12 20t-4.962-2.038T5 13t2.037-4.962T12 6h.38l-1.272 1.273a.488.488 0 0 0 0 .708q.165.165.356.168a.49.49 0 0 0 .357-.162l1.921-1.94a.78.78 0 0 0 .243-.566.77.77 0 0 0-.243-.565l-1.96-1.941a.484.484 0 0 0-.713.006.52.52 0 0 0-.162.354.49.49 0 0 0 .162.354L12.381 5H12a7.8 7.8 0 0 0-3.118.626A8.1 8.1 0 0 0 6.34 7.34a8.1 8.1 0 0 0-1.714 2.542A7.8 7.8 0 0 0 4 13q0 1.663.626 3.118.625 1.455 1.713 2.543a8.1 8.1 0 0 0 2.543 1.713Q10.337 21 12 21"
    />
  </>
)
export default Forward
